import { DataSource, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutInfoPacketPreview extends Layout {
    panelPreview: Panel;
    sourceInformationPacket: DataSource;
}
